import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countiesFilter',
    standalone: false
})
export class CountiesFilterPipe implements PipeTransform {

  transform(items: any, propertyName: string, searchCounty: any,): any {    
    if (!items || !searchCounty) {
      return items;
  }
  searchCounty = searchCounty.trim().toUpperCase();
    return items.filter((item:any) => item.countyName.toUpperCase().indexOf(searchCounty) !== -1);
  }

}
